import React, { useState } from "react";
import SearchInput from "../BottomButtons/SearchInput";
import styled from "@emotion/styled";
import Headline from "../../../components/base/atoms/Headline";
import NewInput from "../forms/NewInput";
import useStore from "../BottomButtons/store";
import { navigate } from "../../../hooks/navigation";
import ContentContainer from "../ContentContainer";

const SearchBarWrapper = styled(ContentContainer)`
    background-color: rgb(230, 0, 40);
    padding: 100px;
    color: #05235f;
    font-size: 18px;

    ${({ theme }) => theme.breakpoints.upTo.medium.css`
         padding: 25px;
    `}

    button {
        background-color: white !important;
        border-top: 1px solid #aaaaaa;
        border-right: 1px solid #aaaaaa;
        border-bottom: 1px solid #aaaaaa;
        border-left: none;
    }
`;

const StyledHeadline = styled(Headline)`
    color: white;
    font-size: 24px;
    padding-bottom: 10px;
`;

const InputContainer = styled.div`
    max-width: 686px;
    width: 100%;
    margin: 0 auto;
`;

const SearchBar = () => {
    const { setOpen } = useStore();
    const [searchTerm, setSearchTerm] = useState("");

    const onSearch = (event) => {
        if (
            event.type === "click" ||
            (event.type === "keypress" && event.key === "Enter")
        ) {
            void navigate(`/suche/${searchTerm}`);
            setSearchTerm("");
            setOpen(null);
        }
    };

    const onLocalChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <SearchBarWrapper>
            <StyledHeadline center={true}>
                Nicht gefunden, was Du suchst?
            </StyledHeadline>
            <InputContainer>
                <NewInput
                    id="global-search"
                    placeholder="Suche"
                    value={searchTerm}
                    onChange={onLocalChange}
                    maxWidth={200}
                    handleClick={onSearch}
                    onKeyPress={onSearch}
                    buttonIconColor="#05235f"
                />
            </InputContainer>
        </SearchBarWrapper>
    );
};
export default SearchBar;
